module.exports = __webpack_public_path__ + "img/jixieshou.77a52157.jpg";